import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  padding: 0.5rem 2rem;
`;

const Header = styled.div`
  width: 100%;
  position: relative;
`;

const Close = styled.div`
  cursor: pointer;
  height: 1.5rem;
  width: 1.5rem;
  position: absolute;
  right: -20px;
  top: -20px;
  svg {
    path {
      fill: ${({ theme }) => theme.colors.hapiGrey20};
    }
  }
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 140%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.25rem;
  button {
    flex-shrink: 0;
    &:first-child {
      background-color: transparent;
      border: none;
      color: ${({ theme }) => theme.colors.hapiGrey20};
    }
  }
`;

export default {
  Container,
  Header,
  Title,
  Close,
  ButtonContainer,
};
